import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60a5a919"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-flex-col tw-w-full tw-min-h-16 tw-border-0 tw-border-t tw-border-solid tw-border-[#EFF0F1]
       `)
}
const _hoisted_2 = { class: "tw-flex tw-items-center tw-w-full tw-truncate tw-max-h-5" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[13px] tw-font-medium" }
const _hoisted_4 = { class: "tw-ml-[15px]" }
const _hoisted_5 = { class: "tw-w-6 tw-h-full" }

import { ref } from "vue";
import ArrowDownTableIcon from "@/components/svgs/arrowDownTableIcon.vue";
import IssuesNumberDots from "@/components/scanning/issuesNumberDots.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'scanningTypesCollapseItem',
  props: {
    title: {},
    className: {},
    scanItems: {}
  },
  setup(__props: any) {



const isOpen = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_b_collapse = _resolveComponent("b-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tw-flex tw-items-center tw-justify-between tw-pt-[23px] tw-pb-[25px] tw-px-[25px] tw-cursor-pointer", ` ${_ctx.className ? _ctx.className : _ctx.className} ${
        isOpen.value ? 'tw-bg-[#F2F8FF]' : 'tw-bg-[#FFF]'
      }`]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isOpen.value = !isOpen.value), ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(IssuesNumberDots, {
            severity: _ctx.scanItems,
            hidden: true
          }, null, 8, ["severity"])
        ])
      ]),
      _createElementVNode("button", _hoisted_5, [
        _createVNode(ArrowDownTableIcon, {
          class: _normalizeClass({
            'right-arrow-icon': true,
            'right-arrow-icon-show': isOpen.value,
          })
        }, null, 8, ["class"])
      ])
    ], 2),
    _createVNode(_component_b_collapse, { visible: isOpen.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["tw-py-[25px] tw-px-[25px]", `${isOpen.value ? 'tw-bg-[#f2f8ff80]' : 'tw-bg-[#FFF]'}`])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 8, ["visible"])
  ]))
}
}

})